import MaskedInput from 'react-text-mask';
import React from 'react';

/**
 * MUI v5 le pasa el ref a un inputComponent personalizado via React ref
 * (requiere forwardRef), ya no via la prop inputRef del patron de MUI v4.
 */
const TextMaskCustom = React.forwardRef((props, ref) => (
  <MaskedInput
    {...props}
    ref={(instance) => {
      const node = instance ? instance.inputElement : null;
      if (typeof ref === 'function') {
        ref(node);
      } else if (ref) {
        ref.current = node;
      }
    }}
    placeholderChar={'\u2000'}
  />
));

TextMaskCustom.displayName = 'TextMaskCustom';

export default TextMaskCustom;
